import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
const SelectorColor = (props) => {
    const { t } = useTranslation();
    return (React.createElement("label", { className: classNames('selector__menu__item', !props.isNotAvailableSelectable && !(props === null || props === void 0 ? void 0 : props.isBoutiqueExclusive) && props.disabled && 'is-disabled', props.selected && 'selected', props.isInverted && 'inverted') },
        React.createElement("input", { type: "radio", onChange: () => {
                props.onSelect(props.item);
            }, "aria-label": props.label, name: `color-selector-` + props.productUuid, value: props.value, defaultChecked: props.selected }),
        React.createElement("span", { "aria-hidden": "true", className: classNames('selector__menu__item__label') },
            props.label,
            props.enableOutofstockLabel && props.isOutOfStock ? ` - ${t('label.outofstock')}` : ''),
        props.children));
};
export default SelectorColor;
